import moment from 'moment';
import { Box, Typography, Grid } from '@mui/material';

import { FBoxContainer, FHSkeletonLoader } from '../../../../components/base';
import { FORTA_WHITE } from '../../../../utils/colors';
import { useProviderDetailsState } from '../hooks';
import { BASIC_INFO_ROW_SX } from '../styles';

export function ProviderOtherInfo() {
  const { provider, loading } = useProviderDetailsState();

  return (
    <FBoxContainer sx={{ height: '100%' }}>
      {loading ? (
        <>
          <FHSkeletonLoader height={30} width={110} sx={{ mb: 0.5 }} />
          <FHSkeletonLoader
            rowCount={6}
            height={20}
            sx={{ mt: 2 }}
            containerStyles={{ mt: 1 }}
            width={250}
          />
        </>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Typography variant="h6" mb={2}>
            Other Info
          </Typography>
          <Grid container p={1} sx={{ backgroundColor: FORTA_WHITE, borderRadius: '10px' }}>
            <Grid item xs={5}>
              <Typography>Address:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.street_address_line_one}</Typography>
              <Typography>{provider?.street_address_line_two}</Typography>
              <Typography>
                {provider?.street_address_zip} {provider?.street_address_city}{' '}
                {provider?.street_address_state}
              </Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>NPI:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.npi}</Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Start date of certification:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>
                {provider?.date_certification_start
                  ? moment(provider.date_certification_start).format('MM/DD/YYYY')
                  : ''}
              </Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>End date of certification:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>
                {provider?.date_certification_end
                  ? moment(provider.date_certification_end).format('MM/DD/YYYY')
                  : ''}
              </Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>State License:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.state_license}</Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Requires EVV:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.evv_required ? 'Yes' : 'No'}</Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </FBoxContainer>
  );
}
